<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import alertImage from 'dashboard/assets/images/sales-registration-alert.svg';

const props = defineProps({
  progress: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const incomplete = computed(() =>
  ['imovel', 'vendedores', 'compradores'].some(
    key => Number(props.progress?.[key] || 0) < 100
  )
);
</script>

<template>
  <div>
    <aside
      v-if="incomplete"
      class="mx-auto mt-[5px] w-full max-w-[1160px] sm:mt-[30px]"
      data-test="sales-registration-delivery-notice"
    >
      <div
        class="flex flex-wrap items-center justify-center rounded-[10px] border border-[#E0E7EB] bg-white p-[15px] shadow-[0_2px_4px_0_rgb(0_0_0_/_0.08),0_0_6px_0_rgb(0_0_0_/_0.02)] sm:flex-nowrap sm:justify-start sm:pr-[35px]"
      >
        <img
          :src="alertImage"
          :alt="t('SALES.DELIVERY_NOTICE.IMAGE_ALT')"
          class="h-[100px] w-[90px] shrink-0 object-contain"
          data-test="sales-registration-delivery-notice-image"
        />
        <p
          class="ml-6 min-w-0 text-[1.1rem] leading-[1.45] text-[#5D696F] sm:text-xl"
        >
          {{ t('SALES.DELIVERY_NOTICE.PREFIX') }}
          <strong>{{ t('SALES.DELIVERY_NOTICE.REAL_ESTATE_LIEN') }}</strong>
          {{ t('SALES.DELIVERY_NOTICE.MIDDLE') }}
          <strong>{{ t('SALES.DELIVERY_NOTICE.PHOTO_DOCUMENT') }}</strong>
          {{ t('SALES.DELIVERY_NOTICE.SUFFIX') }}
        </p>
      </div>
    </aside>
  </div>
</template>
